import { getFormatter } from 'next-intl/server';

import { GTMMaterialType } from '@/fo/api/gtm';
import { BlogEntityTypeEnum, GetBlogPostsQuery } from '@/fo/api/magento';
import { ArticleItem } from '@/fo/ui/article/list/base';
import { UiKitLabelBaseProps } from '@/fo/ui/kit/label/base';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { entityTypeToPageType, urlMap } from '../consts';
import { BlogPageType } from '../types';

const materialTypeMap: Record<BlogEntityTypeEnum, GTMMaterialType> = {
  [BlogEntityTypeEnum.Article]: 'article',
  [BlogEntityTypeEnum.News]: 'news',
  [BlogEntityTypeEnum.ExpertVideo]: 'video'
};

export const mapPostsToArticle = async (
  posts: GetBlogPostsQuery['mpBlogPosts']
) => {
  const format = await getFormatter();

  const mappedPosts: ArticleItem[] =
    posts?.items
      ?.filter((item) => item !== null)
      .map((post) => {
        if (!post?.post_id || !post?.name || !post?.url_key) {
          return null;
        }

        const tag = post.categories?.items?.[0];

        const author = post.authors?.[0];
        const doctor = post.authors?.[1];
        const type = post.type ?? BlogEntityTypeEnum.Article;

        return {
          id: post.post_id,
          title: post.name,
          type,
          materialType: materialTypeMap[type],
          ...(tag &&
            tag.name &&
            tag.url_key && {
              label: [
                {
                  id: tag.url_key,
                  title: tag.name,
                  customColor: tag.color ?? undefined,
                  textColor: tag.color ? 'var(--color-white)' : undefined,
                  children: tag.name,
                  as: 'link',
                  href: `/about-skin/${urlMap[post.type ? entityTypeToPageType[post.type] : BlogPageType.Article]}/categories/${tag.url_key}`
                } as UiKitLabelBaseProps & { id: string }
              ]
            }),

          image: post.small_image
            ? '/' + post.small_image
            : staticMediaUrl('blog/placeholder.png'),
          description: post.short_description ?? undefined,
          rating: post.rating_summary ?? undefined,
          href: `/about-skin/${urlMap[post.type ? entityTypeToPageType[post.type] : BlogPageType.Article]}/${post.url_key}`,
          date: format.dateTime(new Date(post.publish_date ?? ''), {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          }),
          isoDate: post.publish_date ?? undefined,
          readTime: post.time_to_read ?? undefined,
          avatar: author?.photo ?? undefined,
          doctorAvatar: doctor?.photo ?? undefined,
          withDoctor: post.with_doctor ?? false
        };
      })
      .filter((item) => item !== null) ?? [];

  return mappedPosts;
};
